import { useState } from "react";
import { useForm } from "react-hook-form";
import { UPDATE_ADDRESS_ROUTE } from "@api-routes";
import { MERGE_PATCH_HEADER } from "@constants";
import { getStateToPayload } from "../mappers/updateUserAddressMapper";
import { IBillingAddress, IUserAddress } from "@common/eircode/Interface/IAddressForm";
import { useFetch } from "@common/hook/useFetch";

export const useBillingAddress = (
    billingAddress: IUserAddress,
    setIsModalOpen: (isModalOpen: boolean) => void,
    setDisableEdit: (isModalOpen: boolean) => void
) => {
    const [isEditing, setIsEditing] = useState(false);
    const [hasSameDeliveryAddress, setHasSameDeliveryAddress] = useState(false);

    const [updateUserAddressState, { patch }] = useFetch();

    const formMethods = useForm<IUserAddress>({ defaultValues: billingAddress });

    const updateAddress = (address: IBillingAddress) => {
        patch<boolean>(UPDATE_ADDRESS_ROUTE, { body: address, headers: MERGE_PATCH_HEADER }).then(
            (updateAddressResponse) => {
                if (updateAddressResponse) {
                    setIsEditing(false);
                    setDisableEdit(true);
                    setIsModalOpen(true);
                }
            }
        );
    };

    const submitUserAddress: any = formMethods.handleSubmit(() => {
        const formData = formMethods.getValues();
        const newBillingAddress: IBillingAddress = getStateToPayload(formData);
        updateAddress(newBillingAddress);
    });

    return {
        formMethods,
        editing: { isEditing, setIsEditing },
        sameAddress: { hasSameDeliveryAddress, setHasSameDeliveryAddress },
        submitUserAddress,
        updateUserAddressState,
    };
};
